export default "__VITE_ASSET__Dx0Q2rDC__"